import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { HonorarioFidelizadoCreationContent } from './components/HonorarioFidelizadoCreationContent';

export default function AdminHonorarioFidelizadoCreation() {
  return (
    <MainContent
      component={<HonorarioFidelizadoCreationContent />}
      titulo='Honorario Fidelizado'
      noBackground
    />
  );
}
